import { useKeycloak } from "@react-keycloak/web";
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

const FormDataContext = createContext();

export const useFormData = () => useContext(FormDataContext);

export const FormDataProvider = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  const [userData, setFormData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    phone: "",
    addressLineOne: "",
    addressLineTwo: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    associations: [],
    email: "",
    roles: [],
    isAAUser: null,
    isOperationUser: null,
  });

  const [isProfileFetched, setIsProfileFetched] = useState(false);

  const fetchUserData = useCallback(async () => {
    if (!initialized || !keycloak.authenticated || isProfileFetched) return;

    try {
      const keycloakProfile = await keycloak.loadUserProfile();
      const roles = keycloak.tokenParsed.realm_access.roles || [];

      const isOperationUser =
        roles.some((role) => role.startsWith("AA_OPS_ROLE")) &&
        !roles.some((role) => role.includes("AA_ADMIN"));

      const isAAUser = roles.some((role) => role.startsWith("AA_"));

      setFormData({
        ...keycloakProfile,
        roles,
        isAAUser,
        isOperationUser,
      });
      setIsProfileFetched(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }, [initialized, keycloak, isProfileFetched]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <FormDataContext.Provider value={{ userData, setFormData }}>
      {children}
    </FormDataContext.Provider>
  );
};
